import React from "react"
import "./styles.css"

import BtnMinusMin from "../../../assets/btn-minus-min.svg"
import BtnMinus1 from "../../../assets/btn-minus-1.svg"
import BtnPlus1 from "../../../assets/btn-plus-1.svg"
import BtnPlusMax from "../../../assets/btn-plus-max.svg"

const SkillItem = (props) => {
  const { skill, skillLevel, skillIndex, handleClickDisplayInfoSkill, handleClickUpdateSkill } = props

  return (
    <li className="item-container">
      <img
        id="logoSkill"
        src={skill.logo}
        alt={skill.name}
        onClick={(e) => handleClickDisplayInfoSkill(e, skillIndex, skill)}
      ></img>
      <section>
        <img
          className="btn-levels"
          id="btnMinusMin"
          src={BtnMinusMin}
          alt="MinusMax"
          onClick={(e) => handleClickUpdateSkill(e, skillIndex, skill, 0)}
        />
        <img
          className="btn-levels"
          id="btnMinus1"
          src={BtnMinus1}
          alt="Minus1"
          onClick={(e) => handleClickUpdateSkill(e, skillIndex, skill, -1)}
        />
        <span className="skill-level">{skillLevel}</span>
        <img
          className="btn-levels"
          id="btnPlus1"
          src={BtnPlus1}
          alt="Plus1"
          onClick={(e) => handleClickUpdateSkill(e, skillIndex, skill, 1)}
        />
        <img
          className="btn-levels"
          id="btnPlusMax"
          src={BtnPlusMax}
          alt="PlusMax"
          onClick={(e) =>
            handleClickUpdateSkill(
              e,
              skillIndex,
              skill,
              skill.levelsInfo.length
            )
          }
        />
      </section>
    </li>
  )
}

export default React.memo(SkillItem)
